import ButtonBase from '@mui/material/ButtonBase';
import classnames from 'classnames';
import { ReactNode } from 'react';

import LoadingComponent from '../Loading';

import styles from './styles.module.scss';

type ButtonProps = {
  children: ReactNode;
  loading?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  style?: React.CSSProperties;
  disabled?: boolean;
};

export function ButtonComponent({
  children,
  loading = false,
  className = '',
  type = 'button',
  onClick = () => null,
  style = {},
  disabled = false
}: ButtonProps) {
  return (
    <ButtonBase
      type={type}
      className={classnames(styles.button, { [className]: className, [styles.disabled]: disabled })}
      onClick={disabled ? () => null : onClick}
      style={style}
      disabled={loading ? true : disabled}
    >
      {loading ? <LoadingComponent mini color="neutral" /> : children}
    </ButtonBase>
  );
}
